import { API } from '@config';
import { ContactUsGenerationAdministrationFaxTable } from '@src/types/ContactUsGenerationAdministrationFax';

export const getGenerationAdministrationFax = async () => {
  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(`${API}/api/contact-us-generation-administration-faxes?populate=File&sort=id%3Adesc`, options);
  const data: ContactUsGenerationAdministrationFaxTable = await response.json();

  return data;
};
